import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
	Divider,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { makeStyles } from "@mui/styles";
import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";

const useStyles = makeStyles(() => ({
	drawingsButton: {
		backgroundColor: "rgba(147, 112, 219, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(147, 112, 219, 0.2)",
		},
	},
	attachmentsButton: {
		backgroundColor: "rgba(255, 165, 0, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(255, 165, 0, 0.4)",
		},
	},
	lotoButton: {
		backgroundColor: "rgba(50, 205, 50, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(50, 205, 50, 0.2)",
		},
	},
	partsButton: {
		backgroundColor: "rgba(70, 130, 180, 0.1)",
		"&:hover": {
			backgroundColor: "rgba(70, 130, 180, 0.2)",
		},
	},
	dialogActions: {
		padding: 20,
		justifyContent: "center",
	},
}));

interface Props {
	open: boolean;
	onClose: () => void;
	onOpenAssetPartsPicker: () => void;
	onOpenAssetLOTOPicker: () => void;
	onOpenAssetAttachmentsPicker: () => void;
	onOpenAssetDrawingsPicker: () => void;
}

export const ImportAssetResourcesDialog = ({
	open,
	onClose,
	onOpenAssetPartsPicker,
	onOpenAssetLOTOPicker,
	onOpenAssetAttachmentsPicker,
	onOpenAssetDrawingsPicker,
}: Props) => {
	const classes = useStyles();

	const {
		state: { assetDrawings, assetAttachments, assetParts, assetLOTO },
	} = useWorkOrderModalsContext();

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle style={{ paddingBottom: 5 }}>
				<Typography variant="h5">Import Asset Resources</Typography>
			</DialogTitle>
			<Divider />

			<DialogContent>
				<Typography style={{ paddingBottom: 5 }}>
					The asset to which this work order is assigned has resources
					available. <br />
					You can review and assign them to the work order:
				</Typography>
				<Grid2 container spacing={2} style={{ padding: "10px 0" }}>
					<Grid2 size={{ xs: 12, sm: 6 }}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.drawingsButton}`}
							onClick={onOpenAssetDrawingsPicker}
							disabled={assetDrawings.length === 0}
						>
							Import Drawings ({assetDrawings.length})
						</Button>
					</Grid2>
					<Grid2 size={{ xs: 12, sm: 6 }}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.attachmentsButton}`}
							onClick={onOpenAssetAttachmentsPicker}
							disabled={assetAttachments.length === 0}
						>
							Import Attachments ({assetAttachments.length})
						</Button>
					</Grid2>
					<Grid2 size={{ xs: 12, sm: 6 }}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.lotoButton}`}
							onClick={onOpenAssetLOTOPicker}
							disabled={assetLOTO.length === 0}
						>
							Import LOTO ({assetLOTO.length})
						</Button>
					</Grid2>
					<Grid2 size={{ xs: 12, sm: 6 }}>
						<Button
							variant="contained"
							fullWidth
							className={` ${classes.partsButton}`}
							onClick={onOpenAssetPartsPicker}
							disabled={assetParts.length === 0}
						>
							Import Parts ({assetParts.length})
						</Button>
					</Grid2>
				</Grid2>
			</DialogContent>
			<Divider />
			<DialogActions className={classes.dialogActions}>
				<Grid2 container>
					<Grid2 size={{ md: 12, xs: 12 }}>
						<Button
							fullWidth
							variant="contained"
							color="inherit"
							onClick={onClose}
						>
							Close
						</Button>
					</Grid2>
				</Grid2>
			</DialogActions>
		</Dialog>
	);
};
